import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { useTranslation, Trans } from 'react-i18next';
import { useState, useRef } from "react";
import { Link } from "react-router-dom";

import hero from '../assets/contest-closed-hero.jpg';

import kids from '../assets/home-apply-now.jpg';
import kidsteam from '../assets/home-team.jpg';
import players from '../assets/team-oreo-players.png';
import cakesters_en from '../assets/new-cakesters-en.png';
import cakesters_fr from '../assets/new-cakesters-fr.png';

import team_hor_en from '../assets/Grid Horizontal.jpg';
import team_ver_en from '../assets/Grid Vertical.jpg';
import team_hor_fr from '../assets/Grid Horizontal FR.jpg';
import team_ver_fr from '../assets/Grid Vertical FR.jpg';

// const bgvideo = "/video/OREO_NHLPA_Hero_Edit_V3_Widescreen_Textless_ENG_111825.mp4";
// const videopath = "/video/OREO_SPFA_Homepage_Edit_V2_720.mp4";

export default function Home(){
    const { t, i18n } = useTranslation();

    const [ clickedVid, setClickedVid ] = useState(-1);
    const bgVid = useRef(null);

    // const navigate = 
    const toggleClick = ()=>{
        if (clickedVid>0) {
            bgVid.current?.play();
            setClickedVid(-1);
        } else {
            bgVid.current?.pause();
            setClickedVid(1);
        }
    }

    return (
        <Container fluid as='main' className="home">
            <Row className="video-bg align-items-end ">
                <img src={hero} alt={t('homepage.title')} className='video-bg' />
                <Col>
                <Container><Row><Col xs={12} lg={8} className="py-5">
                <h1>{t('homepage.title')}</h1>
                <p>{t('homepage.subtitle')}</p>
                </Col></Row></Container></Col>
            </Row>
            <Row className="stuff-bg">
                <Container fluid><Row className="align-items-center">
                <Col xs={12} sm={6} className="py-5 order-sm-2 px-sm-4">
                    {/* <h2 dangerouslySetInnerHTML={{__html:t('homepage.section1.super')}} className="text-uppercase"></h2> */}
                    <h3 dangerouslySetInnerHTML={{__html:t('homepage.section1.title')}}></h3>
                    <p><Trans i18nKey="homepage.section1.body" components={[<Link to="/rules" />]} /></p>
                    <Link to="/recipients" className="button">{t('homepage.section1.cta')}</Link>
                </Col>
                <Col xs={12} sm={6} className="p-0">
                    <img src={kids} alt="Oreo Kids" className="img-fluid object-fit-cover" />
                </Col>
                </Row></Container>
            </Row>
            <Row className="dark-blue-bg py-2 text-white">
                <Col><Container><Row className="align-items-center">
                <Col xs={12} className="text-center">
                    <h3>{t('homepage.section3.title')}</h3>
                </Col>
                </Row></Container></Col>
                <img src={i18n.resolvedLanguage==='fr'?team_hor_fr:team_hor_en} alt="Team OREO - players" className="players dt-only" />
                <img src={i18n.resolvedLanguage==='fr'?team_ver_fr:team_ver_en} alt="Team OREO - players" className="players mb-only" />
            </Row>
            <Row className="dark-blue-bg py-5 text-white">
                <Col><Container><Row className="align-items-center">
                <Col xs={12} sm={8} className="order-sm-2">
                    <img src={kidsteam} alt="Team OREO - kids" className="border border-2 " />
                </Col>
                <Col xs={12} sm={4} className="px-sm-4">
                    <h3 dangerouslySetInnerHTML={{__html:t('homepage.section2.title')}}></h3>
                    <p dangerouslySetInnerHTML={{__html:t('homepage.section2.body')}}></p>
                    {/* <Link to="/teamoreo" className="button">{t('homepage.section2.cta')}</Link> */}
                </Col>
                </Row></Container></Col>
            </Row>
            <Row className="light-blue-bg py-5">
                <Col><Container><Row className="align-items-center">
                <Col xs={12} sm={8} >
                    <img src={i18n.resolvedLanguage==='fr'?cakesters_fr:cakesters_en} alt="OREO Cakesters" />
                </Col>
                <Col xs={12} sm={4} className="px-sm-4">
                <h3 dangerouslySetInnerHTML={{__html:t('homepage.section4.title')}}></h3>
                <p dangerouslySetInnerHTML={{__html:t('homepage.section4.body')}}></p>
                <Link to={t('homepage.section4.link')} target="_blank" className="button">{t('homepage.section4.cta')}</Link>
                </Col>
                </Row></Container></Col>
            </Row>
            
            <Modal 
                show={clickedVid>-1} 
                onHide={toggleClick} 
                size="xl"
                // fullscreen="sm-down"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton closeVariant="white" />
                <Modal.Body>
                    <video controls autoPlay playsInline>
                        <source src={t('homepage.videopath')} type="video/mp4"></source>
                        {/* <track label="English" kind="subtitles" srcLang="en"
                            src={`/video/${playerENSubPaths[clickedVid]}`} />
                        <track label="Français" kind="subtitles" srcLang="fr"
                            src={`/video/${playerFRSubPaths[clickedVid]}`} /> */}
                    </video>
                </Modal.Body>
            </Modal>
        </Container>
    );
}